import M$plugin$Toponomysearch from '/tmp/toponomysearch/src/facade/js/toponomysearch';
import M$control$ToponomysearchControl from '/tmp/toponomysearch/src/facade/js/toponomysearchcontrol';
import M$impl$control$ToponomysearchControl from '/tmp/toponomysearch/src/impl/ol/js/toponomysearchcontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.Toponomysearch = M$plugin$Toponomysearch;
window.M.control.ToponomysearchControl = M$control$ToponomysearchControl;
window.M.impl.control.ToponomysearchControl = M$impl$control$ToponomysearchControl;
